




























































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";
import Context from "@/mixins/context";
import { ConfirmModalModes } from "@/data/enums";
import { ClientRoutes } from "@/data/enums/router";

@Component
export default class CProdAutoRenewMsg extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  // Data

  public isProcessing = false;
  public readonly clientRoutes = ClientRoutes;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get hasAutoExpire() {
    return this.cProdData.hasAutoExpireEnabled;
  }

  public get renewOn() {
    return !this.cProdData.hasAutoRenewDisabled;
  }

  public get renewOff() {
    return this.cProdData.hasAutoRenewDisabled;
  }

  public get canCreate() {
    return this.cProdData.canCreateNextInvoice;
  }

  public get hasUnpaidInvoices() {
    return (
      this.cProdData.unpaidInvoices?.length ||
      this.cProdData.unpaidOverdueInvoices?.length
    );
  }

  public get uMessageProps() {
    return {
      isProcessing: this.isProcessing,
      type: this.hasAutoExpire
        ? "is-danger"
        : this.renewOn && !this.hasUnpaidInvoices
        ? "is-info"
        : "is-warning"
    };
  }

  public async process(method) {
    if (this.isProcessing) return;
    try {
      this.isProcessing = true;
      await Promise.all([method()]);
    } finally {
      this.isProcessing = false;
    }
  }

  public async confirmDisableRenew() {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.turn_off_auto_renew"),
          message: this.$t("_sentence.cprod.confirm_turn_off_auto_renew"),
          mode: ConfirmModalModes.BUTTON,
          type: "is-warning"
        },
        events: {
          confirmed: async () => {
            try {
              await this.process(() =>
                this.$cProdMethods.toggleAutoRenew(false)
              );
            } finally {
              confirm.close();
            }
          }
        }
      }
    });
  }
}
